import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/write-now/program_timers/${resource.id}/edit`} />
  ]
}

export default buildMenuItems
